/**
 * Defensive read-time normalizer for DiaryDay documents.
 *
 * The canonical v1 -> v2 body conversion (meals-centered shape) runs as an RxDB
 * schema migration when the local database opens. This module is the safety net
 * for the one case the schema migration can't cover: a legacy-shaped body that
 * arrives from the server via replication AFTER the local migration has already
 * run (RxDB migrations only touch documents already present at open time).
 *
 * It reuses the exact same pure transform as the RxDB migration so there is a
 * single source of truth for the conversion.
 */

import {
  isLegacyDiaryDayBody,
  normalizeDiaryDayBody,
} from "@macro-tracker/models";
import type { DiaryDay, DiaryDayBody } from "./diaryDays";

/** Returns true if the body is still in the legacy (pre-`meals`) shape. */
export const needsBackfill = (body: DiaryDayBody | unknown): boolean =>
  isLegacyDiaryDayBody(body);

export const backfillDiaryDayBody = (body: DiaryDayBody): DiaryDayBody =>
  normalizeDiaryDayBody(body);

export const backfillDiaryDay = (day: DiaryDay): DiaryDay => {
  const body = backfillDiaryDayBody(day.body);
  return body === day.body ? day : { ...day, body };
};
